import { ModalParams, ModalSize } from "../ui/Modal/ModalBody";
import TaskEdit from "../components/Task/Edit/TaskEdit";
import { stores } from "../utils/store";
import Settings from "../components/Settings/Settings";
import SkillsPage from "../components/SkillsPage";

export function openModal(modalParams: ModalParams): void {
    stores.UI.modal.set(modalParams);
}

export function closeModal() {
    stores.UI.modal.set(undefined as any);
}

export enum GlobalModal {
    ADD_TASK, EDIT_TASK, STATS, SETTINGS,
}

const modals = {
    [GlobalModal.ADD_TASK]: () => ({ size: ModalSize.MEDIUM, content: <TaskEdit /> } as ModalParams),
    [GlobalModal.EDIT_TASK]: (props: any) => ({ size: ModalSize.MEDIUM, content: <TaskEdit task={props} /> } as ModalParams),
    [GlobalModal.STATS]: (props: any) => ({ size: ModalSize.MEDIUM, content: <SkillsPage />, naked: true } as ModalParams),
    [GlobalModal.SETTINGS]: () => ({ size: ModalSize.BIG, content: <Settings></Settings> } as ModalParams)
}

export function showGlobalModal(modalType: GlobalModal, params?: any) {
    openModal(modals[modalType](params))
}

document.addEventListener('keydown', (e) => { if (e.key === "Escape") closeModal() })
